(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-dosage-unit', {
            parent: 'entity',
            url: '/med-dosage-unit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Dosage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-units.html',
                    controller: 'MedDosageUnitController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-dosage-unit-detail', {
            parent: 'entity',
            url: '/med-dosage-unit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Dosage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-detail.html',
                    controller: 'MedDosageUnitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedDosageUnit', function($stateParams, MedDosageUnit) {
                    return MedDosageUnit.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-dosage-unit',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-dosage-unit-detail.edit', {
            parent: 'med-dosage-unit-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-dialog.html',
                    controller: 'MedDosageUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedDosageUnit', function(MedDosageUnit) {
                            return MedDosageUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-dosage-unit.new', {
            parent: 'med-dosage-unit',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-dialog.html',
                    controller: 'MedDosageUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-dosage-unit', null, { reload: 'med-dosage-unit' });
                }, function() {
                    $state.go('med-dosage-unit');
                });
            }]
        })
        .state('med-dosage-unit.edit', {
            parent: 'med-dosage-unit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-dialog.html',
                    controller: 'MedDosageUnitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedDosageUnit', function(MedDosageUnit) {
                            return MedDosageUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-dosage-unit', null, { reload: 'med-dosage-unit' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-dosage-unit.delete', {
            parent: 'med-dosage-unit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-dosage-unit/med-dosage-unit-delete-dialog.html',
                    controller: 'MedDosageUnitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedDosageUnit', function(MedDosageUnit) {
                            return MedDosageUnit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-dosage-unit', null, { reload: 'med-dosage-unit' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
